module.exports = __webpack_public_path__ + "static/snow-border-278e382bf12a52a3c280dbab1a7d5828.svg";